<template>
  <div class="bg-primary-300 lg:bg-transparent">
    <div class="lg:grid lg:grid-cols-12">
      <div
        class="relative z-10 lg:z-0 lg:col-span-11 lg:col-start-2 lg:row-start-1 lg:bg-transparent"
      >
        <div
          class="absolute inset-x-0 h-1/2 bg-white lg:hidden"
          aria-hidden="true"
        />
        <div class="mx-auto px-4 lg:p-0">
          <div
            class="aspect-h-6 aspect-w-10 sm:aspect-h-1 sm:aspect-w-2 lg:aspect-w-10 lg:aspect-h-5 relative"
          >
            <TLazyimg
              v-if="image"
              :src="image"
              classes-img="block w-full h-full rounded-3xl object-cover object-center shadow-2xl"
              alt=""
            />
          </div>
        </div>
      </div>

      <div
        class="relative z-0 lg:z-10 lg:col-span-6 lg:col-start-1 lg:row-start-1 lg:flex lg:flex-col lg:justify-center"
      >
        <div class="bg-primary-300 lg:rounded-3xl">
          <div class="relative space-y-6 px-4 py-12 sm:py-16 lg:px-6">
            <TTitle
              :tag="'h2'"
              size="2xl"
              color="text-primary-900"
              classes="mb-0"
            >
              {{ title }}
            </TTitle>
            <TText v-if="subtitle">
              {{ subtitle }}
            </TText>
            <UButton
              :ui="mobileFullWidthButton"
              color="neutral"
              variant="subtle"
              size="xl"
              :label="buttonText"
              :to="link"
              external
              @click="emit('button-click', $event)"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { mobileFullWidthButton } from '~~/modules/design-system/utils/nuxt-ui-config/components/button'

export interface propsInterface {
  image: string
  imageAlt: string
  title: string
  subtitle?: string
  buttonText: string
  link: string
}

defineProps<propsInterface>()
const emit = defineEmits(['button-click'])
</script>
